export enum AuthStatus {
  unknow,
  authenticated,
  unauthenticated,
}
